import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router';
import { RootState } from '../../reducers';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import * as actions from '../../actions/generalActions';
import * as adminActions from '../../actions/admin';
import { Button, EButtonType } from '../../components/Button';
import 'react-quill/dist/quill.snow.css';
import { useQuill } from 'react-quilljs';
import { useEffect, useRef, useState } from "react";
import { isMobile } from "../../constants/constants";
import TranslatedText from "../../components/TranslatedText";

interface Props {
    history: any;
    actions: any;
    intl: any;
    admin: any;
    adminActions: any;
    loading: boolean;
    buttonLoader: boolean;
}

const OfferConditions = (props: Props) => {
    const [offerConditions, setOfferConditions] = useState<string>('');
    const [livePreview, setLivePreview] = useState<string>('');
    const hasPopulated = useRef(false);
    const { quill, quillRef } = useQuill();

    useEffect(() => {
        props.adminActions.getOfferConditions();
    }, []);

    useEffect(() => {
        const conditions = props.admin?.offerConditions?.conditions;
        if (conditions) {
            setOfferConditions(conditions);
            setLivePreview(conditions);
        }
    }, [props.admin.offerConditions]);

    // Pre-populate editor once — when both quill is ready and saved content exists
    useEffect(() => {
        if (quill && offerConditions && !hasPopulated.current) {
            quill.clipboard.dangerouslyPasteHTML(offerConditions);
            hasPopulated.current = true;
        }
    }, [quill, offerConditions]);

    // Live preview — update as user types
    useEffect(() => {
        if (quill) {
            quill.on('text-change', () => {
                setLivePreview(quill.root.innerHTML);
            });
        }
    }, [quill]);

    function saveOfferConditions() {
        const html = quill.root.innerHTML;
        props.adminActions.saveConditionsForOffer(
            { conditions: html },
            props.admin?.offerConditions?.id
        );
    }

    return (
        <div className="admin-page offerConditions">
            <div className={`conditions-editor-panel ${isMobile ? 'w-100' : ''}`}>
                <div className="conditions-panel-header">
                    <h3><TranslatedText id="offer.offerConditions" defaultMessage="Kushtet e ofertes"/></h3>
                    <p className="conditions-subtitle">Shkruani kushtet që do të shfaqen në fund të çdo oferte.</p>
                </div>
                <div className="quillContainer" ref={quillRef} />
                <Button
                    isLoading={props?.buttonLoader}
                    isDisabled={props?.buttonLoader}
                    submit={true}
                    className="w-100 mt-3"
                    buttonType={EButtonType.GreyButton}
                    onClick={saveOfferConditions}>
                    <TranslatedText id="offer.saveOfferConditions" defaultMessage="Ruaj kushtet e ofertes"/>
                </Button>
            </div>
            {!isMobile && (
                <div className="conditions-preview-panel">
                    <div className="conditions-panel-header">
                        <h3>Pamja paraprake</h3>
                        <p className="conditions-subtitle">Kështu do të duket teksti në ofertë.</p>
                    </div>
                    <div className="conditions-preview-content">
                        {livePreview ? (
                            <div dangerouslySetInnerHTML={{ __html: livePreview }}/>
                        ) : (
                            <p className="conditions-preview-placeholder">Kushtet do të shfaqen këtu...</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}


function mapGlobalStateToProps(state: RootState, ownProps: any) {
    return {
        ...ownProps,
        ...state.app,
        admin: state.admin
    }
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
    return {
        actions: bindActionCreators(actions as any, dispatch),
        adminActions: bindActionCreators(adminActions as any, dispatch),
    }
}

export default withRouter(connect(mapGlobalStateToProps, mapDispatchToProps)(injectIntl(OfferConditions as any)));